import { module } from "angular";
import { CancelVerificationComponent } from "./CancelVerificationComponent";

module("mmAuth").component("irCancelUserVerification", new CancelVerificationComponent());
